import { render, staticRenderFns } from "./AttitudeDetail.vue?vue&type=template&id=2e0abcf2&scoped=true"
import script from "./AttitudeDetail.vue?vue&type=script&lang=js"
export * from "./AttitudeDetail.vue?vue&type=script&lang=js"
import style0 from "./AttitudeDetail.vue?vue&type=style&index=0&id=2e0abcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0abcf2",
  null
  
)

export default component.exports